import {Link, useLocation, useSearchParams} from 'react-router-dom';
import {useForm} from 'react-hook-form';
import {FormTextField} from '../../ui/forms/input-field/text-field/text-field';
import {Button} from '../../ui/buttons/button';
import {Form} from '../../ui/forms/form';
import {
  LoginPayload,
  useLogin,
  useGetWxQrcode,
  useQrcodeLoginStatus,
  useAutoWxLogin,
} from '../requests/use-login';
import {FormCheckbox} from '../../ui/forms/toggle/checkbox';
import {LinkStyle} from '../../ui/buttons/external-link';
import {SocialAuthSection} from './social-auth-section';
import {AuthLayout} from './auth-layout/auth-layout';
import {Trans} from '../../i18n/trans';
import {StaticPageTitle} from '../../seo/static-page-title';
import {useContext} from 'react';
import {
  SiteConfigContext,
  SiteConfigContextValue,
} from '../../core/settings/site-config-context';
import {useSettings} from '../../core/settings/use-settings';
import {Spin} from 'antd';
import WXSDK from '../../wx/lib';
import {useAuth} from '../use-auth';

interface Props {
  onTwoFactorChallenge: () => void;
}
export function LoginPage({onTwoFactorChallenge}: Props) {
  const [searchParams] = useSearchParams();
  const {pathname} = useLocation();

  const isWorkspaceLogin = pathname.includes('workspace');
  const searchParamsEmail = searchParams.get('email') || undefined;

  const {branding, registration, site, social} = useSettings();
  const siteConfig = useContext(SiteConfigContext);

  const demoDefaults =
    site.demo && !searchParamsEmail ? getDemoFormDefaults(siteConfig) : {};
  const form = useForm<LoginPayload>({
    defaultValues: {remember: true, email: searchParamsEmail, ...demoDefaults},
  });

  const autoLogin = useAutoWxLogin();

  const {isLoggedIn} = useAuth();


  // alert(WXSDK.instance.isInWxEnvironment())
  // alert(`环境检查: ${ WXSDK.instance.isInWxEnvironment() ? '微信' : '非微信' }`)
  if (WXSDK.instance.isInWxEnvironment()) {
    const searchParams = new URLSearchParams(location.search);

    const code = searchParams.get('code');

    if (isLoggedIn) {
      location.href = '/drive';
      return;
    }

    if (!code) {
      WXSDK.instance.login();
    } else {
      autoLogin(code);
    }

    return <></>;
  }
  // const login = useLogin(form);

  // 微信登陆
  const {value, loading} = useGetWxQrcode();

  useQrcodeLoginStatus(value?.rand_code);

  const heading = isWorkspaceLogin ? (
    <Trans
      values={{siteName: branding?.site_name}}
      message="To join your team on :siteName, login to your account"
    />
  ) : (
    <Trans message="Sign in to your account" />
  );

  const message = !registration.disable && (
    <Trans
      values={{
        a: parts => (
          <Link className={LinkStyle} to="/register">
            {parts}
          </Link>
        ),
      }}
      message="Don't have an account? <a>Sign up.</a>"
    />
  );

  const isInvalid = !form.formState.isValid;

  return (
    <AuthLayout heading="微信扫描二维码登录" message={''}>
      {loading ? (
        <Spin spinning={loading}>
          <div style={{width: '60%', height: 200, margin: '0 auto'}} />
        </Spin>
      ) : (
        <img
          src={value?.qr_code}
          alt=""
          style={{width: '60%', margin: '0 auto'}}
        />
      )}
    </AuthLayout>
  );
}

function getDemoFormDefaults(siteConfig: SiteConfigContextValue) {
  if (siteConfig.demo.loginPageDefaults === 'randomAccount') {
    // random number between 0 and 100, padded to 3 digits
    const number = Math.floor(Math.random() * 100) + 1;
    const paddedNumber = String(number).padStart(3, '0');
    return {
      email: `admin@demo${paddedNumber}.com`,
      password: 'admin',
    };
  } else {
    return {
      email: 'admin@admin.com',
      password: 'admin',
    };
  }
}
